import { createApiTokenHandler } from 'Utils/Api/RefreshTokenHandler';
import { authSDK } from 'Utils/AuthSDK';
import { profileSDK } from 'Utils/ProfileSDK';
import { getTokenExpirations, getUser } from 'Utils/UserCookie';

//API calls from Auth SDK which are generally for MVPD

export const getAuthentication = (options = {}) =>
  createApiTokenHandler(async (fetchNewToken) => {
    try {
      return await authSDK().getAdobeRegCode(options);
    } catch (e) {
      if (e.statusCode === 401) return fetchNewToken();
      throw e;
    }
  });

export const checkAuthenticationRequest = (options = {}) =>
  createApiTokenHandler(async (fetchNewToken) => {
    const { deviceId, deviceType, requestor } = options;
    const user = getUser() || {};
    const { refreshToken } = user;
    try {
      let result;
      if (refreshToken) {
        result = await profileSDK().checkAdobeAuthNRefresh({ refreshToken, deviceId, deviceType, requestor });
      } else {
        //Note: there is also a profileSDK().checkAdobeAuthN method
        result = await authSDK().checkAdobeAuthN({ deviceId });
      }
      let expirations = {};
      if (result.refreshToken) {
        expirations = getTokenExpirations(result.tokenExpiration);
      }
      return { ...result, ...expirations };
    } catch (e) {
      if (e.statusCode === 401) return fetchNewToken();
      throw e;
    }
  });

export const getMvpdEntitlements = () =>
  createApiTokenHandler(async (fetchNewToken) => {
    try {
      const result = await authSDK().getEntitlements();
      const entitlements = result?.entitlements;
      return entitlements && Object.keys(entitlements);
    } catch (e) {
      if (e.statusCode === 401) return fetchNewToken();
      throw e;
    }
  });

export const getUserMetadata = () =>
  createApiTokenHandler(async (fetchNewToken) => {
    try {
      return await authSDK().getUserMetadata();
    } catch (e) {
      if (e.statusCode === 401) return fetchNewToken();
      throw e;
    }
  });

export const logoutOfMVPD = () =>
  createApiTokenHandler(async (fetchNewToken) => {
    try {
      return await authSDK().logoutOfMVPD();
    } catch (e) {
      if (e.statusCode === 401) return fetchNewToken();
      throw e;
    }
  });
